export enum FeatureToggle {
  sfpSandboxUserVisible = 'rt_sfp_sandbox_user_visible',
  sfpSandboxVisible = 'rt_sfp_sandbox_visible',
}
